module.exports = __webpack_public_path__ + "img/filter_5.9abbb649.svg";